"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stackups = exports.createDefaultHoles = exports.createDefaultViaConfigurationsMap = exports.staticLayoutLayers = exports.defaultLayerThickness = exports.staticLayoutLayerUids = void 0;
exports.getAllStackupConfigLabels = getAllStackupConfigLabels;
exports.isOverlayLayer = isOverlayLayer;
exports.isSolderMaskLayer = isSolderMaskLayer;
exports.isSolderPasteLayer = isSolderPasteLayer;
exports.isMiddleCopperLayer = isMiddleCopperLayer;
exports.isDielectricLayer = isDielectricLayer;
exports.isElectricLayer = isElectricLayer;
exports.isCopperLayer = isCopperLayer;
exports.isCopperMaterial = isCopperMaterial;
exports.getCopperLayersCount = getCopperLayersCount;
exports.getOrderedCopperLayers = getOrderedCopperLayers;
exports.getLayerIdentifier = getLayerIdentifier;
exports.matchLayerIdentifier = matchLayerIdentifier;
// Buyer beware: this is actually used in foreign files, even though lint claims that it is not exported!
const shared_1 = require("@buildwithflux/shared");
const bakedRule_1 = require("../bakedRule");
const color_1 = require("./color");
const constants_1 = require("./constants");
function getAllStackupConfigLabels() {
    const results = [];
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    Object.values(exports.stackups).forEach((stackupConfigs) => {
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.values(stackupConfigs).forEach((stackupConfig) => {
            if (!stackupConfig.archived) {
                results.push(stackupConfig.label);
            }
        });
    });
    return results;
}
function isOverlayLayer(layer, orientation) {
    return layer?.type === "Overlay" && (!orientation || layer.orientation === orientation);
}
function isSolderMaskLayer(layer, orientation) {
    return layer?.type === "Solder Mask" && (!orientation || layer.orientation === orientation);
}
function isSolderPasteLayer(layer, orientation) {
    return layer?.type === "Solder Paste" && (!orientation || layer.orientation === orientation);
}
function isMiddleCopperLayer(layer) {
    return isCopperLayer(layer) && !layer.orientation;
}
function isDielectricLayer(layer) {
    return layer?.type === "Dielectric";
}
function isElectricLayer(layer) {
    return layer?.type === "Signal" || layer?.type === "Power Plane";
}
function isCopperLayer(layer) {
    if (isCopperMaterial(layer?.material)) {
        return true;
    }
    return false;
}
function isCopperMaterial(material) {
    if (material === "Copper" || material?.startsWith("CF-")) {
        return true;
    }
    return false;
}
function getCopperLayersCount(layers) {
    const layersList = Array.isArray(layers) ? layers : Object.values(layers);
    return layersList.filter(isCopperLayer).length;
}
function getOrderedCopperLayers(layers) {
    const layersList = (Array.isArray(layers) ? layers : Object.values(layers ?? {}));
    return layersList.filter(isCopperLayer).sort((a, b) => a.order - b.order);
}
function getLayerIdentifier(layer) {
    return layer.orientation ?? layer.name;
}
function matchLayerIdentifier(layerState, layerUidOrNameOrOrientation) {
    return (layerState.uid === layerUidOrNameOrOrientation ||
        layerState.orientation === layerUidOrNameOrOrientation ||
        layerState.name === layerUidOrNameOrOrientation);
}
var staticLayoutLayerUids;
(function (staticLayoutLayerUids) {
    staticLayoutLayerUids["metaLayerUid"] = "meta";
    staticLayoutLayerUids["outlineLayerUid"] = "outline";
    staticLayoutLayerUids["holesLayerUid"] = "holes";
})(staticLayoutLayerUids || (exports.staticLayoutLayerUids = staticLayoutLayerUids = {}));
exports.defaultLayerThickness = (0, shared_1.mmToMeters)(0.01);
exports.staticLayoutLayers = {
    meta: {
        uid: staticLayoutLayerUids.metaLayerUid,
        type: "Metadata",
        order: -10,
        name: "Metadata",
        color: "#fff",
        thickness: 0,
    },
    outline: {
        uid: staticLayoutLayerUids.outlineLayerUid,
        type: "Metadata",
        order: -9,
        name: "Board Outline",
        color: "#39B54A",
        thickness: 0,
    },
    holes: {
        uid: staticLayoutLayerUids.holesLayerUid,
        type: "Metadata",
        order: -8,
        name: "Drill Holes",
        color: "#7CB342",
        thickness: 0,
    },
};
const createDefaultViaConfigurationsMap = (layerCount) => ({
    // The default through-hole via's uid must be "throughHole" for backward compatibility
    [constants_1.DEFAULT_THROUGH_HOLE_VIA_UID]: {
        uid: constants_1.DEFAULT_THROUGH_HOLE_VIA_UID,
        name: "Through-hole",
        order: 1,
        enabled: true,
        readonly: true,
        segments: [
            {
                key: constants_1.DEFAULT_THROUGH_HOLE_VIA_UID,
                mechanicalProcess: bakedRule_1.HoleMechanicalProcess.drill,
                holeSize: constants_1.DEFAULT_VIA_HOLE_SIZE,
                size: constants_1.DEFAULT_VIA_SIZE,
                startLayer: 1,
                endLayer: layerCount,
            },
        ],
    },
});
exports.createDefaultViaConfigurationsMap = createDefaultViaConfigurationsMap;
const createDefaultHoles = () => [
    {
        uid: "defaultThroughHole",
        mechanicalProcess: bakedRule_1.HoleMechanicalProcess.drill,
        holeSize: "*",
        minSize: "*",
    },
    {
        uid: "defaultLaserHole",
        mechanicalProcess: bakedRule_1.HoleMechanicalProcess.laser,
        holeSize: "*",
        minSize: "*",
    },
];
exports.createDefaultHoles = createDefaultHoles;
const stackupsWithoutViasAndHoles = {
    standard: {
        "1": {
            // Total thickness 1.5604mm // Not an altium preset
            key: "standard-1-layer",
            label: "Standard 1 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4.0,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "FR-4",
                    thickness: (0, shared_1.mmToMeters)(1.5),
                    dielectricMaterial: "FR-4",
                    dielectric: 4.29,
                },
            },
        },
        "2": {
            // Total thickness 1.6194mm // This is Altium 2 layers Preset
            key: "standard-2-layer",
            label: "Standard 2 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(1.4986),
                    dielectricMaterial: "Core",
                    dielectric: 4.3,
                },
                "6": {
                    uid: "6",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 6,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "7": {
                    uid: "7",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 7,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Bottom",
                },
                "8": {
                    uid: "8",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 8,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "9": {
                    uid: "9",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 9,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "3": {
            // Total thickness 1.42016mm // This is Altium 4 layers Preset
            key: constants_1.DEFAULT_LAYOUT_STACKUP_KEY,
            label: "Standard 4 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.12954),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "6": {
                    uid: "6",
                    name: "Dielectric 2",
                    order: 6,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.12954),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "7": {
                    uid: "7",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 7,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "8": {
                    uid: "8",
                    name: "Dielectric 3",
                    order: 8,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.7112),
                    dielectricMaterial: "Core",
                    dielectric: 4.8,
                },
                "9": {
                    uid: "9",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 9,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "10": {
                    uid: "10",
                    name: "Dielectric 4",
                    order: 10,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.12954),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "11": {
                    uid: "11",
                    name: "Dielectric 5",
                    order: 11,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.12954),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "12": {
                    uid: "12",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 12,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "13": {
                    uid: "13",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 13,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Bottom",
                },
                "14": {
                    uid: "14",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 14,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "15": {
                    uid: "15",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 15,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "4": {
            // Total thickness 1.6mm // JLC7628 4-Layer Stackup
            key: "jlc7628-4-layer",
            label: "JLC7628 4 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0125), // 12.5um dk 3.8
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.8,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.2104),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.6,
                },
                "6": {
                    uid: "6",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 6,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.0152),
                },
                "7": {
                    uid: "7",
                    name: "Core",
                    order: 8,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(1.065),
                    dielectricMaterial: "Core",
                    dielectric: 4.6,
                },
                "8": {
                    uid: "8",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 8,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.0152),
                },
                "9": {
                    uid: "9",
                    name: "Dielectric 2",
                    order: 9,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.2104),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.6,
                },
                "10": {
                    uid: "10",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 10,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "11": {
                    uid: "11",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 11,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0125),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.8,
                    orientation: "Bottom",
                },
                "12": {
                    uid: "12",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 12,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "13": {
                    uid: "13",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 13,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "5": {
            // Total thickness 1.6mm // JLC3313 4-Layer Stackup
            key: "jlc3313-4-layer",
            label: "JLC3313 4 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0125),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.8,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.0994),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.05,
                },
                "6": {
                    uid: "6",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 6,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.0152),
                },
                "7": {
                    uid: "7",
                    name: "Core",
                    order: 8,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(1.265),
                    dielectricMaterial: "Core",
                    dielectric: 4.6,
                },
                "8": {
                    uid: "8",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 8,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.0152),
                },
                "9": {
                    uid: "9",
                    name: "Dielectric 2",
                    order: 9,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.0994),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.05,
                },
                "10": {
                    uid: "10",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 10,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "11": {
                    uid: "11",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 11,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0125),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.8,
                    orientation: "Bottom",
                },
                "12": {
                    uid: "12",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 12,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "13": {
                    uid: "13",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 13,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "6": {
            // Total thickness 1.6mm // PCBWay 4-Layer Stackup
            key: "pcbway-4-layer",
            label: "PCBWay 4 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0125),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.8,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.11),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.29,
                },
                "6": {
                    uid: "6",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 6,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035), // 1/1oz Cu = 35um = 0.035mm
                },
                "7": {
                    uid: "7",
                    name: "Core",
                    order: 7,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(1.13), // pcbway core is 1.2mm that includes L1 and L2
                    dielectricMaterial: "Core",
                    dielectric: 4.6,
                },
                "8": {
                    uid: "8",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 8,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035), // 1/1oz Cu = 35um = 0.035mm
                },
                "9": {
                    uid: "9",
                    name: "Dielectric 2",
                    order: 9,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.11),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.29,
                },
                "10": {
                    uid: "10",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 10,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "11": {
                    uid: "11",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 11,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0125),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.8,
                    orientation: "Bottom",
                },
                "12": {
                    uid: "12",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 12,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "13": {
                    uid: "13",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 13,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "7": {
            // Total thickness 1.6mm // AISLER 4-Layer Stackup
            key: "aisler-4-layer",
            label: "AISLER 4 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.025),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.7,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.04),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.06813),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "6": {
                    uid: "6",
                    name: "Dielectric 2",
                    order: 6,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.06813),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "7": {
                    uid: "7",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 7,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035), // 1/1oz Cu = 35um = 0.035mm
                },
                "8": {
                    uid: "8",
                    name: "Core",
                    order: 8,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(1.13),
                    dielectricMaterial: "Core",
                    dielectric: 4.6,
                },
                "9": {
                    uid: "9",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 9,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035), // 1/1oz Cu = 35um = 0.035mm
                },
                "10": {
                    uid: "10",
                    name: "Dielectric 3",
                    order: 10,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.06813),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "11": {
                    uid: "11",
                    name: "Dielectric 4",
                    order: 11,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.06813),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "12": {
                    uid: "12",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 12,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.04),
                    orientation: "Bottom",
                },
                "13": {
                    uid: "13",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 13,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.025),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.7,
                    orientation: "Bottom",
                },
                "14": {
                    uid: "14",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 14,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "15": {
                    uid: "15",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 15,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "8": {
            // Total thickness 1.6mm // AISLER 6-Layer Stackup
            key: "aisler-6-layer",
            label: "AISLER 6 Layer",
            archived: true,
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.025),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.7,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.04),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.06813),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "6": {
                    uid: "6",
                    name: "Dielectric 2",
                    order: 6,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.06813),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "7": {
                    uid: "7",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 7,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035), // 1/1oz Cu = 35um = 0.035mm
                },
                "8": {
                    uid: "8",
                    name: "Core 1",
                    order: 8,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.2),
                    dielectricMaterial: "Core",
                    dielectric: 4.6,
                },
                "9": {
                    uid: "9",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 9,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035), // 1/1oz Cu = 35um = 0.035mm
                },
                "10": {
                    uid: "10",
                    name: "Dielectric 3",
                    order: 10,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.1705),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.6,
                },
                "11": {
                    uid: "11",
                    name: "Dielectric 4",
                    order: 11,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.1705),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.6,
                },
                "12": {
                    uid: "12",
                    name: "Dielectric 5",
                    order: 12,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.1705),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.6,
                },
                "13": {
                    uid: "13",
                    name: "Mid-Layer 3",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer3,
                    order: 13,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035), // 1/1oz Cu = 35um = 0.035mm
                },
                "14": {
                    uid: "14",
                    name: "Core 2",
                    order: 14,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.2),
                    dielectricMaterial: "Core",
                    dielectric: 4.6,
                },
                "15": {
                    uid: "15",
                    name: "Mid-Layer 4",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer4,
                    order: 13,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035), // 1/1oz Cu = 35um = 0.035mm
                },
                "16": {
                    uid: "16",
                    name: "Dielectric 6",
                    order: 16,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.06813),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "17": {
                    uid: "17",
                    name: "Dielectric 7",
                    order: 17,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.06813),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "18": {
                    uid: "18",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 18,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.04),
                    orientation: "Bottom",
                },
                "19": {
                    uid: "19",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 19,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.025),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 3.7,
                    orientation: "Bottom",
                },
                "20": {
                    uid: "20",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 20,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "21": {
                    uid: "21",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 21,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "9": {
            // Total thickness 1.60193 // This is Altium 6 layers Preset
            key: "standard-6-layer",
            label: "Standard 6 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "6": {
                    uid: "6",
                    name: "Dielectric 2",
                    order: 6,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "7": {
                    uid: "7",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 7,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "8": {
                    uid: "8",
                    name: "Dielectric 3",
                    order: 8,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.4572),
                    dielectricMaterial: "Core",
                    dielectric: 4.7,
                },
                "9": {
                    uid: "9",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 9,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "10": {
                    uid: "10",
                    name: "Dielectric 4",
                    order: 10,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "11": {
                    uid: "11",
                    name: "Dielectric 5",
                    order: 11,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "12": {
                    uid: "12",
                    name: "Mid-Layer 3",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer3,
                    order: 12,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "13": {
                    uid: "13",
                    name: "Dielectric 6",
                    order: 13,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.4572),
                    dielectricMaterial: "Core",
                    dielectric: 4.7,
                },
                "14": {
                    uid: "14",
                    name: "Mid-Layer 4",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer4,
                    order: 14,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "15": {
                    uid: "15",
                    name: "Dielectric 7",
                    order: 15,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "16": {
                    uid: "16",
                    name: "Dielectric 8",
                    order: 16,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "17": {
                    uid: "17",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 17,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "18": {
                    uid: "18",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 18,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Bottom",
                },
                "19": {
                    uid: "19",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 19,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "20": {
                    uid: "20",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 20,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "10": {
            // Total thickness 1.58557mm // This is Altium 6 layers Preset
            key: "standard-8-layer",
            label: "Standard 8 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "6": {
                    uid: "6",
                    name: "Dielectric 2",
                    order: 6,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "7": {
                    uid: "7",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 7,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "8": {
                    uid: "8",
                    name: "Dielectric 3",
                    order: 8,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.2286),
                    dielectricMaterial: "Core",
                    dielectric: 4.5,
                },
                "9": {
                    uid: "9",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 9,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "10": {
                    uid: "10",
                    name: "Dielectric 4",
                    order: 10,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "11": {
                    uid: "11",
                    name: "Dielectric 5",
                    order: 11,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "12": {
                    uid: "12",
                    name: "Mid-Layer 3",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer3,
                    order: 12,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "13": {
                    uid: "13",
                    name: "Dielectric 6",
                    order: 13,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.2286),
                    dielectricMaterial: "Core",
                    dielectric: 4.5,
                },
                "14": {
                    uid: "14",
                    name: "Mid-Layer 4",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer4,
                    order: 14,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "15": {
                    uid: "15",
                    name: "Dielectric 7",
                    order: 15,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "16": {
                    uid: "16",
                    name: "Dielectric 8",
                    order: 16,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "17": {
                    uid: "17",
                    name: "Mid-Layer 5",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer5,
                    order: 17,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "18": {
                    uid: "18",
                    name: "Dielectric 9",
                    order: 18,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.2286),
                    dielectricMaterial: "Core",
                    dielectric: 4.5,
                },
                "19": {
                    uid: "19",
                    name: "Mid-Layer 6",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer6,
                    order: 19,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "20": {
                    uid: "20",
                    name: "Dielectric 10",
                    order: 20,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "21": {
                    uid: "21",
                    name: "Dielectric 11",
                    order: 21,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "22": {
                    uid: "22",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 22,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "23": {
                    uid: "23",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 23,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Bottom",
                },
                "24": {
                    uid: "24",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 24,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "25": {
                    uid: "25",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 25,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "11": {
            // Total thickness 1.62001mm // This is Altium 10 layers Preset
            key: "standard-10-layer",
            label: "Standard 10 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "6": {
                    uid: "6",
                    name: "Dielectric 2",
                    order: 6,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "7": {
                    uid: "7",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 7,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "8": {
                    uid: "8",
                    name: "Dielectric 3",
                    order: 8,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.127),
                    dielectricMaterial: "Core",
                    dielectric: 4.3,
                },
                "9": {
                    uid: "9",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 9,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "10": {
                    uid: "10",
                    name: "Dielectric 4",
                    order: 10,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "11": {
                    uid: "11",
                    name: "Dielectric 5",
                    order: 11,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "12": {
                    uid: "12",
                    name: "Mid-Layer 3",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer3,
                    order: 12,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "13": {
                    uid: "13",
                    name: "Dielectric 6",
                    order: 13,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.127),
                    dielectricMaterial: "Core",
                    dielectric: 4.3,
                },
                "14": {
                    uid: "14",
                    name: "Mid-Layer 4",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer4,
                    order: 14,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "15": {
                    uid: "15",
                    name: "Dielectric 7",
                    order: 15,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "16": {
                    uid: "16",
                    name: "Dielectric 8",
                    order: 16,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "17": {
                    uid: "17",
                    name: "Mid-Layer 5",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer5,
                    order: 17,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "18": {
                    uid: "18",
                    name: "Dielectric 9",
                    order: 18,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.127),
                    dielectricMaterial: "Core",
                    dielectric: 4.3,
                },
                "19": {
                    uid: "19",
                    name: "Mid-Layer 6",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer6,
                    order: 19,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "20": {
                    uid: "20",
                    name: "Dielectric 10",
                    order: 20,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "21": {
                    uid: "21",
                    name: "Dielectric 11",
                    order: 21,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "22": {
                    uid: "22",
                    name: "Mid-Layer 7",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer7,
                    order: 22,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "23": {
                    uid: "23",
                    name: "Dielectric 12",
                    order: 23,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.127),
                    dielectricMaterial: "Core",
                    dielectric: 4.3,
                },
                "24": {
                    uid: "24",
                    name: "Mid-Layer 8",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer8,
                    order: 24,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "25": {
                    uid: "25",
                    name: "Dielectric 13",
                    order: 25,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "26": {
                    uid: "26",
                    name: "Dielectric 14",
                    order: 26,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.07112),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.1,
                },
                "27": {
                    uid: "27",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 27,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "28": {
                    uid: "28",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 28,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Bottom",
                },
                "29": {
                    uid: "29",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 29,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "30": {
                    uid: "30",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 30,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "12": {
            // Total thickness 1.57825mm // This is Altium 12 layers Preset
            key: "standard-12-layer",
            label: "Standard 12 Layer",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.09652),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "6": {
                    uid: "6",
                    name: "Mid-Layer 1",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer1,
                    order: 6,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "7": {
                    uid: "7",
                    name: "Dielectric 2",
                    order: 7,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.1016),
                    dielectricMaterial: "Core",
                    dielectric: 4.4,
                },
                "8": {
                    uid: "8",
                    name: "Mid-Layer 2",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer2,
                    order: 8,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "9": {
                    uid: "9",
                    name: "Dielectric 3",
                    order: 9,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.09652),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "10": {
                    uid: "10",
                    name: "Mid-Layer 3",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer3,
                    order: 10,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "11": {
                    uid: "11",
                    name: "Dielectric 4",
                    order: 11,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.1016),
                    dielectricMaterial: "Core",
                    dielectric: 4.4,
                },
                "12": {
                    uid: "12",
                    name: "Mid-Layer 4",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer4,
                    order: 12,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "13": {
                    uid: "13",
                    name: "Dielectric 5",
                    order: 13,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.10668),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.2,
                },
                "14": {
                    uid: "14",
                    name: "Mid-Layer 5",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer5,
                    order: 14,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "15": {
                    uid: "15",
                    name: "Dielectric 6",
                    order: 15,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.1016),
                    dielectricMaterial: "Core",
                    dielectric: 4.4,
                },
                "16": {
                    uid: "16",
                    name: "Mid-Layer 6",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer6,
                    order: 16,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "17": {
                    uid: "17",
                    name: "Dielectric 7",
                    order: 17,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.10668),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.2,
                },
                "18": {
                    uid: "18",
                    name: "Mid-Layer 7",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer7,
                    order: 18,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "19": {
                    uid: "19",
                    name: "Dielectric 8",
                    order: 19,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.1016),
                    dielectricMaterial: "Core",
                    dielectric: 4.4,
                },
                "20": {
                    uid: "20",
                    name: "Mid-Layer 8",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer8,
                    order: 20,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "21": {
                    uid: "21",
                    name: "Dielectric 9",
                    order: 21,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.09652),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "22": {
                    uid: "22",
                    name: "Mid-Layer 9",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer9,
                    order: 22,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "23": {
                    uid: "23",
                    name: "Dielectric 10",
                    order: 23,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(0.1016),
                    dielectricMaterial: "Core",
                    dielectric: 4.4,
                },
                "24": {
                    uid: "24",
                    name: "Mid-Layer 10",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.midLayer10,
                    order: 24,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                },
                "25": {
                    uid: "25",
                    name: "Dielectric 11",
                    order: 25,
                    type: "Dielectric",
                    material: "Prepreg",
                    thickness: (0, shared_1.mmToMeters)(0.09652),
                    dielectricMaterial: "Prepreg",
                    dielectric: 4.3,
                },
                "26": {
                    uid: "26",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 26,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "27": {
                    uid: "27",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 27,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Bottom",
                },
                "28": {
                    uid: "28",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 28,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "29": {
                    uid: "29",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 29,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
        "13": {
            // Total thickness 1.6194mm // This is will be our default footprint stackup
            key: constants_1.DEFAULT_FOOTPRINT_STACKUP_KEY,
            label: "Footprint",
            layers: {
                ...exports.staticLayoutLayers,
                "1": {
                    uid: "1",
                    name: "Top Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topOverlay,
                    order: 1,
                    type: "Overlay",
                    orientation: "Top",
                    thickness: exports.defaultLayerThickness,
                },
                "2": {
                    uid: "2",
                    name: "Top Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderPaste,
                    order: 2,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Top",
                },
                "3": {
                    uid: "3",
                    name: "Top Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topSolderMask,
                    order: 3,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Top",
                },
                "4": {
                    uid: "4",
                    name: "Top Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.topCopper,
                    order: 4,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Top",
                },
                "5": {
                    uid: "5",
                    name: "Dielectric 1",
                    order: 5,
                    type: "Dielectric",
                    material: "Core",
                    thickness: (0, shared_1.mmToMeters)(1.4986),
                    dielectricMaterial: "Core",
                    dielectric: 4.3,
                },
                "6": {
                    uid: "6",
                    name: "Bottom Copper",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomCopper,
                    order: 6,
                    type: "Signal",
                    material: "Copper",
                    thickness: (0, shared_1.mmToMeters)(0.035),
                    orientation: "Bottom",
                },
                "7": {
                    uid: "7",
                    name: "Bottom Solder Mask",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderMask,
                    order: 7,
                    type: "Solder Mask",
                    material: "Solder Mask",
                    thickness: (0, shared_1.mmToMeters)(0.0254),
                    dielectricMaterial: "Epoxy Liquid",
                    dielectric: 4,
                    orientation: "Bottom",
                },
                "8": {
                    uid: "8",
                    name: "Bottom Solder Paste",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomSolderPaste,
                    order: 8,
                    type: "Solder Paste",
                    material: "PbSn",
                    thickness: (0, shared_1.mmToMeters)(0.01),
                    orientation: "Bottom",
                },
                "9": {
                    uid: "9",
                    name: "Bottom Overlay",
                    color: color_1.colors.canvas.pcb.layout.stackupLayerColors.bottomOverlay,
                    order: 9,
                    type: "Overlay",
                    orientation: "Bottom",
                    thickness: exports.defaultLayerThickness,
                },
            },
        },
    },
};
// Insert vias and holes into default stackups
exports.stackups = Object.entries(stackupsWithoutViasAndHoles).reduce((accCategories, [catergoryKey, category]) => ({
    ...accCategories,
    [catergoryKey]: Object.entries(category).reduce((accStackups, [stackupKey, stackup]) => ({
        ...accStackups,
        [stackupKey]: {
            ...stackup,
            vias: (0, exports.createDefaultViaConfigurationsMap)(getCopperLayersCount(stackup.layers)),
            holes: (0, exports.createDefaultHoles)(),
        },
    }), {}),
}), {});
exports.default = exports.stackups;
//# sourceMappingURL=stackup.js.map